// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.06 12.231a.322.322 0 010-.462l6.56-6.57a1.286 1.286 0 00-1.81-1.825l-7.252 7.263a1.943 1.943 0 000 2.726l7.252 7.263a1.283 1.283 0 002.19-.913 1.289 1.289 0 00-.38-.912l-6.56-6.57z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;